var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var BaseProvider = /** @class */ (function () {
    function BaseProvider() {
        this.loaded = false;
        this.dependenciesLoaded = false;
        this.debouncePromises = {};
    }
    BaseProvider.prototype.ensureDependenciesLoaded = function (providers) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        if (!!this.dependenciesLoaded) return [3 /*break*/, 2];
                        if (this.dependenciesLoadedPromise) {
                            return [2 /*return*/, this.dependenciesLoadedPromise];
                        }
                        this.dependenciesLoadedPromise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var promises, err_2;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        promises = providers.map(function (provider) {
                                            return provider.ensureLoaded(function () { return provider.load(); });
                                        });
                                        return [4 /*yield*/, Promise.all(promises)];
                                    case 1:
                                        _a.sent();
                                        resolve();
                                        return [3 /*break*/, 3];
                                    case 2:
                                        err_2 = _a.sent();
                                        reject(err_2);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, this.dependenciesLoadedPromise];
                    case 1:
                        _a.sent();
                        this.dependenciesLoaded = true;
                        _a.label = 2;
                    case 2: return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        throw err_1;
                    case 4:
                        this.dependenciesLoadedPromise = null;
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    BaseProvider.prototype.ensureLoaded = function (callback, force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var result, err_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        if (this.loaded && !force) {
                            return [2 /*return*/, Promise.resolve()];
                        }
                        if (this.loadedPromise) {
                            return [2 /*return*/, this.loadedPromise];
                        }
                        // Create a wrapping promise around the callback
                        this.loadedPromise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                            var result_1, err_4;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        _a.trys.push([0, 2, , 3]);
                                        return [4 /*yield*/, callback()];
                                    case 1:
                                        result_1 = _a.sent();
                                        return [2 /*return*/, resolve(result_1)];
                                    case 2:
                                        err_4 = _a.sent();
                                        reject(err_4);
                                        return [3 /*break*/, 3];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, this.loadedPromise];
                    case 1:
                        result = _a.sent();
                        this.loaded = true;
                        return [2 /*return*/, result];
                    case 2:
                        err_3 = _a.sent();
                        throw err_3;
                    case 3:
                        this.loadedPromise = null;
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseProvider.prototype.isLoaded = function () {
        return this.loaded;
    };
    BaseProvider.prototype.resetInfo = function () {
        this.loaded = false;
        this.dependenciesLoaded = false;
    };
    /**
     * Provide a central location to fetch a dataset
     * This will prevent us from making duplicate reload calls when a boost:finished event happens or something similar
     */
    BaseProvider.prototype.debounce = function (key, callback, timeout) {
        if (timeout === void 0) { timeout = 0; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.debouncePromises[key] !== undefined) {
                            return [2 /*return*/, this.debouncePromises[key]];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        this.debouncePromises[key] = callback();
                        return [4 /*yield*/, this.debouncePromises[key]];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        setTimeout(function () {
                            delete _this.debouncePromises[key];
                        }, timeout);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return BaseProvider;
}());
export { BaseProvider };
//# sourceMappingURL=base.js.map


// WEBPACK FOOTER //
// ./src/providers/base.ts.pre-build-optimizer.js